<script context="module">
  import { SIZES, TAGS } from './utils'

  export { SIZES, TAGS }
</script>

<script>
  import H1 from './H1'
  import H2 from './H2'
  import Span from './Span'

  import { getClass } from './utils'

  export let tag = undefined
  export let size = undefined

  $: Component = (function (tag) {
    switch (tag) {
      case TAGS.H1:
        return H1

      case TAGS.H2:
        return H2

      default:
        return Span
    }
  })(tag)

  $: className = getClass({ size, className: $$props.class || '' })
</script>

<svelte:component this={Component} {...$$restProps} class={className} on:click>
  <slot />
</svelte:component>
